"use client";
import React, {useEffect} from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {confJson} from "@/app/config/confJson";
import GameTrack, {PrivacyLinkScene} from "@/Core/GameTrack";

interface PrivacyDialogProps extends SDialogProps {
    callAccept?: () => void;
}

export const PrivacyDialogFC: React.FC<PrivacyDialogProps> = (props) => {
    const { fcKey, isOpen, callAccept } = props;
    const {closeDialog } = useDialogMethods(fcKey);
    useEffect(() => {
        console.log("PrivacyDialog initialized");

        return () => {
            console.log("PrivacyDialog disposed");
        };
    }, []);

    /** 接受操作 */
    const onAccept = () => {
        callAccept?.();
        closeDialog();
    };

    if (!isOpen) return null;

    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Center"
            // title={<p className={styles.title}>YOU ARE ALMOST<br/>THERE</p>}
            title="Terms and Conditions"
            buttons={[
                { label: "Accept", onClick: onAccept, style: "greenBtn" },
            ]}
            onClose={props.onClose}
        >
            <div>
                <p>To start playing, you need to accept our</p>
                <p
                    style={{
                        color: "#42FF5D",
                        textDecoration: "underline",
                    }}
                >
                    <span onClick={() => {
                        GameTrack.clickPrivacyLink(PrivacyLinkScene.Service)
                        window.open(confJson.trems_url, "_blank")
                    }}>Terms of Service & </span>
                    <span onClick={() => {
                        GameTrack.clickPrivacyLink(PrivacyLinkScene.Privacy)
                        window.open(confJson.privacy_url, "_blank")
                    }}>Privacy Policy</span>.
                </p>
                <p style={{ marginTop: ".5rem" }}>
                    By using our site, you confirm you're 18+
                    and not a resident of an excluded territory.
                </p>
            </div>
        </SDialogFC>
    );
};
